module.exports = __webpack_public_path__ + "img/workvxkf.496d6e12.jpg";